import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { replaceWithGuestSession, setUserToken } from "../../app/store/auth/authActions";
import { readRawStoredUserToken, USER_TOKEN } from "../../app/store/auth/authMiddleware";
import QueryString from "qs";

const canRefreshStoredToken = (token: any) => !!(token?.rememberMe && token?.refreshToken);

const tokenIsUsable = (token: any) => {
  if (!token?.sessionToken || !token?.userName) {
    return false;
  }
  if (!token.tokenValidTo) {
    return true;
  }
  const expiryTime = new Date(token.tokenValidTo).getTime();
  if (Number.isNaN(expiryTime)) {
    return true;
  }
  return new Date().getTime() <= expiryTime;
};

export default function useFakeSession() {
  const dispatch = useDispatch();

  useEffect(
    () => {
      const storedToken = readRawStoredUserToken();
      if (tokenIsUsable(storedToken) || canRefreshStoredToken(storedToken)) {
        const b2bToken = QueryString.parse(window.location.search.slice(1)).B2BSESSION as string;
        if (b2bToken && storedToken) {
          const overrideToken = { ...storedToken, sessionToken: b2bToken, userName: b2bToken };
          sessionStorage.setItem(USER_TOKEN, JSON.stringify(overrideToken));
          localStorage.removeItem(USER_TOKEN);
          dispatch(setUserToken(overrideToken));
        }
        return;
      }

      dispatch(replaceWithGuestSession());
    }, //eslint-disable-next-line
    []
  );
}
